var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('shared-header',{attrs:{"isTerms":'true',"isRegister":'false'}}),_vm._v(" "),_c('b-container',[_c('shared-terms',{staticClass:"terms my-5 text-left"})],1),_vm._v(" "),_c('shared-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9689b12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/terms/terms.html
// module id = null
// module chunks = 